(() => {
  const shopRoot = window.Shopify?.routes?.root || '/';

  function init(section) {
    if (!section || section.dataset.weekInitialized === 'true') return;
    section.dataset.weekInitialized = 'true';
    const form = section.querySelector('.tz-week__form');
    if (!form) return;
    const variantInput = form.querySelector('[data-week-variant-id]');
    const addButton = form.querySelector('[data-week-add]');
    const addLabel = form.querySelector('[data-week-add-label]');
    const buyButton = form.querySelector('[data-week-buy]');
    const status = form.querySelector('[data-week-status]');
    const image = section.querySelector('.tz-week__image');
    const originalLabel = addLabel?.textContent;
    let busy = false;

    const selectVariant = radio => {
      if (!radio || busy) return;
      variantInput.value = radio.value;
      section.querySelectorAll('.tz-week__weight').forEach(tile => tile.classList.toggle('is-selected', tile.contains(radio)));
      section.querySelector('[data-week-price]').textContent = radio.dataset.price;
      const compare = section.querySelector('[data-week-compare]');
      const saving = section.querySelector('[data-week-saving]');
      compare.textContent = radio.dataset.compare;
      compare.hidden = radio.dataset.hasSaving !== 'true';
      saving.textContent = `${section.dataset.saveLabel || 'Save'} ${radio.dataset.saving}`;
      saving.hidden = radio.dataset.hasSaving !== 'true';
      if (image && radio.dataset.image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = radio.dataset.image;
        image.alt = radio.dataset.imageAlt || '';
      }
      addButton.disabled = buyButton.disabled = false;
      if (addLabel) addLabel.textContent = originalLabel;
      status.textContent = '';
    };

    form.addEventListener('change', event => {
      if (event.target.matches('[data-week-variant]')) selectVariant(event.target);
    });

    const purchase = async buyNow => {
      if (busy || addButton.disabled || buyButton.disabled) return;
      const id = Number(variantInput.value);
      if (!Number.isSafeInteger(id) || id <= 0) return;
      busy = true;
      addButton.disabled = buyButton.disabled = true;
      status.textContent = '';
      try {
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'This product could not be added.');
        if (buyNow) { window.location.assign(`${shopRoot}checkout`); return; }
        status.textContent = 'Added to cart.';
        document.dispatchEvent(new CustomEvent('tazty:cart-notice', { detail: { message: `${result.items?.[0]?.product_title || 'Product'} added to cart` } }));
        try {
          const cartResponse = await fetch(`${shopRoot}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.site-header__cart').forEach(link => {
              const badge = link.querySelector('b');
              if (badge) badge.textContent = cart.item_count;
              link.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
            });
            document.dispatchEvent(new CustomEvent('tazty:cart-updated', { detail: { ...cart, openDrawer: false } }));
          }
        } catch (_) { /* The item was added; a failed count refresh should not show an add error. */ }
      } catch (error) {
        status.textContent = error.name === 'TimeoutError' ? 'Please check your cart before trying again.' : error.message;
      } finally {
        busy = false;
        const selected = form.querySelector('[data-week-variant]:checked');
        const available = selected ? !selected.disabled : form.querySelector('[data-week-default-available]')?.value === 'true';
        addButton.disabled = buyButton.disabled = !available;
      }
    };

    form.addEventListener('submit', event => { event.preventDefault(); purchase(false); });
    buyButton?.addEventListener('click', () => purchase(true));
  }

  const initAll = scope => {
    if (scope.matches?.('[data-week-product]')) init(scope);
    scope.querySelectorAll?.('[data-week-product]').forEach(init);
  };
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  else initAll(document);
})();
